module.exports = __webpack_public_path__ + "static/img/5.0036cc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/5.png
// module id = emaR
// module chunks = 4